import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BlockIcon from '@mui/icons-material/Block';
// material-ui components
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Grid } from '@mui/material';
import { RightsContext } from 'providers/RightsContext';

export const DocumentScoringAttributeListComponent = ({ attributeList, t }) => {
  const { clientSensitiveInfoRead } = useContext(RightsContext);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t('DocumentEdit.Scoring.ScoringAttribute.Name')}</TableCell>
          <TableCell align='right'>{t('DocumentEdit.Scoring.ScoringAttribute.Value')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {attributeList.map(x => {
          return (
            <TableRow key={x.documentScoringAttributeId}>
              <TableCell>{x.name}</TableCell>
              {x.sensitiveInfo && !clientSensitiveInfoRead ? (
                <TableCell align='left' style={{ padding: '0px 0px 4px 0px' }}>
                  <Grid container spacing={1} justifyContent='flex-end'>
                    <Grid item align='left'></Grid>
                    <BlockIcon />
                    <Grid item style={{ paddingLeft: '20px' }}>
                      {t('OfferEdit.Client.IncomeData.SensitiveInfo')}
                    </Grid>
                  </Grid>
                </TableCell>
              ) : (
                <TableCell align='right'>{x.value}</TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

DocumentScoringAttributeListComponent.propTypes = {
  attributeList: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(DocumentScoringAttributeListComponent);
